import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import ATLBTLDigitalSpendChart from './ATLBTLDigitalSpendChart';
import CampaignFunnelChart from './CampaignFunnelChart';
import RegionCampaignHeatmap from './RegionCampaignHeatmap';
import DetailedCampaignTable from './DetailedCampaignTable';
const CampaignPerformanceDashboard: React.FC = () => {
  const kpis = [{
    title: 'Total Campaigns Running',
    value: '24',
    change: '+4',
    isPositive: true,
    subtitle: 'Active campaigns'
  }, {
    title: 'Avg ROI %',
    value: '267%',
    change: '+18%',
    isPositive: true,
    subtitle: 'Return on Investment'
  }, {
    title: 'Impressions vs Conversions',
    value: '1:142',
    change: '-8 pts',
    isPositive: true,
    subtitle: 'Conversion efficiency'
  }];
  return <div data-id="element-6779">
      <DescriptionPanel title="Campaign Performance Analysis" description="Comprehensive view of marketing campaign effectiveness across ATL, BTL, and Digital channels. Track spend efficiency, conversion funnels, and regional impact to optimize campaign strategies and maximize ROI." insights={['24 active campaigns generating ₹403.9L in total spend', 'Digital campaigns leading with 267% average ROI', 'West region showing highest campaign impact with 89% effectiveness', 'Campaign funnel conversion from Reach to Deals at 2.8%']} data-id="element-6780" />
      {/* KPI Tiles */}
      <div className="mb-8" data-id="element-6781">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-6782">
          Campaign Performance Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6783">
          {kpis.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50" data-id="element-6784">
              <div className="flex flex-col h-full" data-id="element-6785">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" data-id="element-6786">
                  {kpi.title}
                </div>
                <div className="text-xs text-gray-400 mb-3" data-id="element-6787">{kpi.subtitle}</div>
                <div className="text-4xl font-bold text-gray-900 mb-3" data-id="element-6788">
                  {kpi.value}
                </div>
                <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-6789">
                  {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-6790" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-6791" />}
                  {kpi.change} vs last quarter
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Main Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-6792">
        <ATLBTLDigitalSpendChart data-id="element-6793" />
        <CampaignFunnelChart data-id="element-6794" />
      </div>
      {/* Region Heatmap - Full Width */}
      <RegionCampaignHeatmap data-id="element-6795" />
      {/* Detailed Campaign Table */}
      <DetailedCampaignTable data-id="element-6796" />
    </div>;
};
export default CampaignPerformanceDashboard;